if (!window.reaHeaderScrollInit) {
  window.reaHeaderScrollInit = true;

  // Threshold, not 0 — avoids flipping solid on sub-pixel scroll jitter or
  // an overscroll bounce on load.
  const SCROLL_THRESHOLD = 40;

  const updateScrolled = () => {
    document.body.classList.toggle('rea-header-scrolled', window.scrollY > SCROLL_THRESHOLD);
  };

  // The transparent header is fixed at the top, so while it's active it
  // needs to sit below the announcement bar(s) rather than assume zero
  // offset — otherwise it overlaps them. Sums every .utility-bar found
  // (the header group can have more than one announcement-bar section
  // stacked) rather than assuming exactly one, and re-measures on resize
  // since height varies with viewport width (can wrap to two lines).
  const updateAnnouncementOffset = () => {
    const bars = document.querySelectorAll('.utility-bar');
    let height = 0;
    bars.forEach((bar) => {
      height += bar.offsetHeight;
    });
    document.documentElement.style.setProperty('--rea-announcement-offset', `${height}px`);
  };

  updateScrolled();
  updateAnnouncementOffset();
  window.addEventListener('scroll', updateScrolled, { passive: true });
  window.addEventListener('resize', updateAnnouncementOffset);
}
